<div class="d-flex flex-wrap align-items-start" [ngClass]="{ 'mb-6': !useCustomLabel && !icon }">
  <label *ngIf="label" class="col-12" [ngClass]="{ 'col-lg-4 col-form-label': !useCustomLabel && !icon, required: required }">
    <span *ngIf="icon" class="svg-icon svg-icon-2 me-2" [inlineSVG]="icon"></span>
    <span [class.fw-bolder]="icon || useCustomLabel">{{ label }}</span>
  </label>

  <div class="col-12" [ngClass]="{ 'col-lg-8': label && !useCustomLabel && !icon, 'mt-3': icon || useCustomLabel }">
    <div class="position-relative">
      <ng-container *ngIf="!searchControl.value && (isLoading | async)" [ngTemplateOutlet]="loaderTpl"></ng-container>
      <input
        matInput
        type="text"
        class="form-control form-control-solid text-black"
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        [placeholder]="placeholder"
        [readonly]="readOnly"
        #trigger="matAutocompleteTrigger"
      />

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event.option.value)">
        <div class="mh-200px overflow-auto" #optionsContainer>
          <mat-option
            *ngFor="let option of filteredOptions$ | async; let last = last"
            #intersection="intersection"
            [value]="option"
            [disabled]="option.disabled"
            appObserveIntersection
            [debounceTime]="300"
            [threshold]="0"
            [root]="optionsContainer"
            [class.is-intersecting]="intersection._isIntersecting && last"
            [ngStyle]="(isLoading | async) ? { opacity: '0.5', 'pointer-events': 'none' } : null"
            (isIntersecting)="last ? isIntersecting($event) : null"
          >
            <span>{{ getOptionLabel(option) }}</span>
            <ng-container *ngIf="option.description">
              <span class="d-block text-gray-700">{{ option.description }}</span>
            </ng-container>
          </mat-option>

          <!-- loader -->
          <mat-option *ngIf="isLoading | async" [style.pointer-events]="'none'" class="position-relative">
            <ng-container [ngTemplateOutlet]="loaderTpl"></ng-container>
          </mat-option>

          <!-- not found -->
          <mat-option *ngIf="(isLoading | async) === false && searchControl.value && (noResults | async)" [style.pointer-events]="'none'" class="position-relative">
            <span class="font-14">Tidak ada data</span>
          </mat-option>
        </div>
      </mat-autocomplete>

      <span
        ngbAutoFocus
        class="svg-icon svg-icon-1 cursor-pointer"
        [inlineSVG]="STRING_CONSTANTS.ICON.IC_ARROW_MINI_DOWN"
        (click)="!readOnly && trigger.openPanel(); $event.stopPropagation()"
      ></span>
    </div>

    <ng-container *ngIf="useChips" [ngTemplateOutlet]="viewChipsTpl"></ng-container>
  </div>
</div>

<ng-template #viewChipsTpl>
  <div [class.mt-5]="hasSelectedChips | async">
    <app-chips #chipsListRef (selectedChips)="handleSelectedChips($event)" />
  </div>
</ng-template>

<ng-template #loaderTpl>
  <span class="indicator-progress font-10">loading...<span class="spinner-border spinner-border-sm align-middle mx-2"></span></span>
</ng-template>
